// hooks/useFetchScheduledEvents.js
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const fetchScheduledEvents = async (getAccessTokenSilently) => {
  // Get the access token from Auth0
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  // Use the token in the authorization header
  const { data } = await axios.get(`${apiUrl}/api/events/scheduled-events`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return data;
};

export const useFetchScheduledEvents = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    "scheduledEvents",
    () => fetchScheduledEvents(getAccessTokenSilently),
    {
      // Optional: React Query configurations such as refetch intervals,
      // enabled/disabled query based on authentication status, etc.
    }
  );
};
